import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { IconButton, Theme } from "@material-ui/core"
import { buttonsStatesColors } from "theme/Button/constants"
import { buttonMainColor, buttonReverseColor } from "theme/Button/utils"
import { TIconButtonProps } from "./IconButton"

type TContainedCSSProps = TIconButtonProps & { theme: Theme }

const containedCSS = (props: TContainedCSSProps) => css`
  color: ${buttonReverseColor(props)};
  background-color: ${buttonMainColor(props)};
  ${props.color === "primary" && buttonsStatesColors.containedPrimary};
  ${props.color === "secondary" && buttonsStatesColors.containedSecondary};
`
export const StyledIconButton = styled(IconButton)<TIconButtonProps>`
  ${props => props.variant === "contained" && containedCSS(props)}
`
